var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.68 12.1818C19.68 11.6145 19.6291 11.069 19.5345 10.5454H12V13.64H16.3055C16.12 14.64 15.5564 15.4872 14.7091 16.0545V18.0618H17.2945C18.8073 16.669 19.68 14.6181 19.68 12.1818Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 20C14.1602 20 15.9711 19.2837 17.2947 18.0618L14.7093 16.0546C13.9929 16.5346 13.0765 16.8182 12.0002 16.8182C9.91653 16.8182 8.15289 15.4109 7.5238 13.52H4.85107V15.5927C6.16744 18.2073 8.87289 20 12.0002 20Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52364 13.52C7.36364 13.04 7.27273 12.5272 7.27273 12C7.27273 11.4727 7.36364 10.96 7.52364 10.48V8.40723H4.85091C4.30909 9.48723 4 10.709 4 12C4 13.2909 4.30909 14.5127 4.85091 15.5927L7.52364 13.52Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 7.18182C13.1747 7.18182 14.2293 7.58545 15.0583 8.37818L17.3529 6.08364C15.9674 4.79273 14.1565 4 12.0002 4C8.87289 4 6.16744 5.79273 4.85107 8.40727L7.5238 10.48C8.15289 8.58909 9.91653 7.18182 12.0002 7.18182Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.5a5d4b0cd598a3c76c1fba124772958e.svg";
export { ForwardRef as ReactComponent };